import { render, staticRenderFns } from "./BeReadyList.vue?vue&type=template&id=738ee64c"
import script from "./BeReadyList.vue?vue&type=script&lang=js"
export * from "./BeReadyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports